<template>
    <div class="w-100">
        <select :name="name" style="display:none" v-model="selected">
            <option v-for="opt in options" v-bind:key="name+'slct'+opt" :value="opt.value">{{opt.label}}</option>  
        </select>
        <div class="w-100 px-3 py-2 my-2 bg-white shadow-sm rounded" v-on:click="isFocus=!isFocus" style="cursor: pointer;user-select:none">
            {{(usedefault&&defaultValue!='')?defaultValue:selected}}
            <hr class="m-0 p-0"/>
        </div>
        
        <div class="w-100" style="position:relative">
            <div class="w-100 px-3 py-3 bg-white shadow-sm rounded mt-2" v-if="isFocus" style="position:absolute;top:0;z-index:800">
                <input type="text" class="w-100 rounded p-1" v-model="searchValue">
                <div class="w-100 mt-1 border border-light rounded" style="overflow-y:scroll;top:0;max-height:250px">
                    <span v-for="opt in options" v-bind:key="name+'lbl'+opt" class="px-1 py-2 selection rounded" :class="[optHasKey(opt.label)?'d-block':'d-none']" v-on:click="dataUpdate(opt)">{{opt.label}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.selection:hover{
    background:#2301e68c;
    color:white;
}
</style>
<script>
export default {
    props:{
        name:{
            type:String,
            default:''
        },
        defaultValue:{
            type:String,
            default:''
        },
        options:Array,
        usedefault:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            selected:this.options[0].label,
            isFocus:false,
            searchValue:''
        }
    },
    methods:{
        optHasKey(val1){
            return val1.toLowerCase().includes(this.searchValue.toLowerCase())
            // if(key==''){
            //     //console.log('oke')
            //     return true;
            // }else{
            //     //console.log('comparing '+val1+' and '+this.searchValue+', result: '+val1.includes(this.searchValue))
            //     if(val1.includes(key)){
            //         console.log('ok')
            //         return true;
            //     }
            // }
            // console.log('fail')
            // return false;
        },
        dataUpdate(data){
            this.selected=data.label;
            this.isFocus=!this.isFocus;
            this.usedefault = false;
            this.$emit('update',data.value);
        }
    }
}
</script>